/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSiteMiscSettingRequestSiteMiscSettingFromJSON, UpdateSiteMiscSettingRequestSiteMiscSettingToJSON } from './UpdateSiteMiscSettingRequestSiteMiscSetting';
export function UpdateSiteMiscSettingRequestFromJSON(json) {
    return UpdateSiteMiscSettingRequestFromJSONTyped(json, false);
}
export function UpdateSiteMiscSettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        siteMiscSetting: !exists(json, 'site_misc_setting')
            ? undefined
            : UpdateSiteMiscSettingRequestSiteMiscSettingFromJSON(json['site_misc_setting'])
    };
}
export function UpdateSiteMiscSettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        site_misc_setting: UpdateSiteMiscSettingRequestSiteMiscSettingToJSON(value.siteMiscSetting)
    };
}
